// extracted by mini-css-extract-plugin
export default {"user-bar":"UsersAvatarBlock_user-bar__YXptZ","user-bar__inner":"UsersAvatarBlock_user-bar__inner__aC28+"};